import {Component, inject, Input, OnDestroy, OnInit, PLATFORM_ID, ChangeDetectionStrategy} from '@angular/core';
import {isPlatformBrowser, NgClass} from '@angular/common';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {DropdownItem} from '@components/navbar/navbar.component';
import {FeatureFlagService} from '@services/feature-flag.service';

@Component({
  selector: 'peps-dropdown-button',
	imports: [
		NgClass,
		RouterLinkActive,
		RouterLink,
	],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './dropdown-button.component.html',
})
export class DropdownButtonComponent implements OnInit, OnDestroy {

  	constructor() {}

	private featureFlagService = inject(FeatureFlagService);
	private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

	@Input() text: string = '';
	@Input() items: DropdownItem[] = [];
	@Input() isMobileNavbar = false;
	@Input() route: string = '';

	isOpen = false;
	isMobile = false;

	select(action: () => void) {
		action();
		if(this.isMobile) {
			this.isOpen = false;
		}
	}

	ngOnInit() {
		if (!this.isBrowser) return;
		this.isMobile = window.innerWidth < 1024;
		window.addEventListener('resize', this.updateDeviceMode.bind(this));
	}

	ngOnDestroy() {
		if (!this.isBrowser) return;
		window.removeEventListener('resize', this.updateDeviceMode.bind(this));
	}

	updateDeviceMode() {
		this.isMobile = window.innerWidth < 1024;
		if (!this.isMobile) this.isOpen = false;
	}

	handleClick() {
		if (this.isMobile) this.isOpen = !this.isOpen;
	}


	getFilteredItems(items: DropdownItem[]): DropdownItem[] {
		return items.filter(item => {
			if (!item.featureFlag) {
				return true;
			}
			return this.featureFlagService.isEnabled(item.featureFlag);
		}).toSorted((a, b) => a.order - b.order);
	}

	isItemBeta(item: DropdownItem): boolean {
		if (!item.featureFlag) return false;
		return this.featureFlagService.isBeta(item.featureFlag);
	}
}
